<template>
  <div class="wishlist-button">
    <b-overlay
      :show="wishlistActionLoading"
      :rounded="false"
      :spinner-small="true"
      bg-color="white"
    >
      <a
        href="javascript:;"
        @click="wishlist_add(sku)"
        v-if="!is_product_in_list(sku)"
        title="Add to wishlist"
      >
        Add to wishlist<svg
          class="bi"
          width="1.3rem"
          height="1.3rem"
          fill="currentColor"
          style="vertical-align: text-bottom"
        >
          <use
            xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#star"
          />
        </svg>
      </a>
      <a
        href="javascript:;"
        @click="wishlist_remove(sku)"
        v-if="is_product_in_list(sku)"
        title="Remove from wishlist"
      >
        Remove<svg
          class="bi"
          width="1.3rem"
          height="1.3rem"
          fill="currentColor"
          style="vertical-align: text-bottom"
        >
          <use
            xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#star-fill"
          />
        </svg>
      </a>
    </b-overlay>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      sku: "",
    };
  },
  props: {
    result: Object,
    respondToDutyChange: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.sku = this.result._id;

    if (this.respondToDutyChange) {
      document.addEventListener("jb_duty_changed", (e) => {
        this.sku = this.sku.substring(0, this.sku.length - 2) + e.detail;
      });
    }
  },
  computed: {
    ...mapGetters({
      is_product_in_list: "wishlist/is_product_in_list",
      wishlistActionLoading: "wishlist/is_loading",
    }),
  },
  methods: {
    ...mapActions({
      wishlist_add: "wishlist/add_item",
      wishlist_remove: "wishlist/remove_item",
    }),
  },
};
</script>
